
import React from 'react';
import { useTheme } from '../context/ColorContext';

const CerezPolitikasi = () => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <div className={`min-h-screen pt-32 pb-20 px-4 md:px-0 container mx-auto max-w-4xl ${isDark ? 'text-white' : 'text-slate-900'}`}>
            <h1 className="text-4xl md:text-6xl font-black uppercase mb-12 tracking-tighter">Çerez Politikası</h1>

            <div className="space-y-8 opacity-80 text-lg font-light leading-relaxed">
                <section>
                    <h2 className="text-2xl font-bold uppercase mb-4 text-[#5AA668]">Çerez nedir?</h2>
                    <p>
                        Çerezler, bir internet sitesini ziyaret ettiğinizde cihazınıza (bilgisayar, telefon veya tablet) yüklenen küçük metin dosyalarıdır. Bu dosyalar, siteyi kullanımınızla ilgili bilgileri saklayarak bir sonraki ziyaretinizde sizi tanımamızı ve deneyiminizi iyileştirmemizi sağlar.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-bold uppercase mb-4 text-[#5AA668]">Hangi Çerezleri Kullanıyoruz?</h2>
                    <p>DÜFA olarak sitemizde temel olarak üç tür çerez kullanmaktayız:</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                        <div className={`p-6 rounded-2xl border ${isDark ? 'bg-white/5 border-white/10' : 'bg-black/5 border-black/5'}`}>
                            <h3 className="font-bold mb-2">Zorunlu Çerezler</h3>
                            <p className="text-sm">Sitenin temel fonksiyonlarının çalışması için gereklidir. Güvenlik ve navigasyon amaçlı kullanılırlar.</p>
                        </div>
                        <div className={`p-6 rounded-2xl border ${isDark ? 'bg-white/5 border-white/10' : 'bg-black/5 border-black/5'}`}>
                            <h3 className="font-bold mb-2">Performans Çerezleri</h3>
                            <p className="text-sm">Sitemizi kaç kişinin ziyaret ettiğini ve nasıl kullandığınızı anlamamıza yardımcı olur. Veriler anonim olarak toplanır.</p>
                        </div>
                        <div className={`p-6 rounded-2xl border ${isDark ? 'bg-white/5 border-white/10' : 'bg-black/5 border-black/5'}`}>
                            <h3 className="font-bold mb-2">Fonksiyonel Çerezler</h3>
                            <p className="text-sm">Dil seçiminiz veya tema tercihiniz gibi ayarları hatırlayarak daha kişisel bir deneyim sunar.</p>
                        </div>
                        <div className={`p-6 rounded-2xl border ${isDark ? 'bg-white/5 border-white/10' : 'bg-black/5 border-black/5'}`}>
                            <h3 className="font-bold mb-2">Hedefleme Çerezleri</h3>
                            <p className="text-sm">Ziyaret alışkanlıklarınıza göre size ilgi çekebilecek içerik ve reklamların sunulması için kullanılır.</p>
                        </div>
                    </div>
                </section>

                <section>
                    <h2 className="text-2xl font-bold uppercase mb-4 text-[#5AA668]">Çerezleri Nasıl Kontrol Edebilirsiniz?</h2>
                    <p>
                        İnternet tarayıcınızın ayarlarını değiştirerek çerezleri engelleyebilir veya silinebilirsiniz. Ancak zorunlu çerezlerin engellenmesi, sitemizdeki bazı özelliklerin doğru çalışmamasına neden olabilir.
                    </p>
                    <p className="mt-4">
                        Tarayıcı ayarlarından çerez tercihlerinizi yönetmek için tarayıcınızın yardım sayfasını ziyaret edebilirsiniz (Chrome, Safari, Firefox, vb.).
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-bold uppercase mb-4 text-[#5AA668]">Bize Ulaşın</h2>
                    <p>
                        Çerez politikamız hakkındaki sorularınız için <span className="text-[#5AA668] font-bold">info@kayalarkimya.com.tr</span> adresinden bizimle iletişime geçebilirsiniz.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default CerezPolitikasi;
